import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './router'
import rem from './libs/rem.js'
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import AwesomePicker from 'vue-awesome-picker';
Vue.use(AwesomePicker);
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar);
import Calendar1 from 'vue2-datepick'; //日期控件

Vue.use(Calendar1); //日期控件






import {
  Alert,
  Confirm,
  Toast
} from 'wc-messagebox'
import 'wc-messagebox/style.css'
Vue.use(Alert)
Vue.use(Confirm)
Vue.use(Toast)

// 配置axios
// import Axios from "axios";
import Axios from "axios";
Vue.prototype.$http = Axios;
Axios.defaults.baseURL = "https://zg.lifejiankang.com/api/";

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

// Axios.interceptors.request.use(function (config) {
//   // Do something before request is sent
//   // console.log(config.headers);
//   // 因为除了登录 其他都需要授权 因此在发起请求的时候 自动让拦截器拦截该请求 并且在该请求身上添加一个请求头字段
//   // 字段名: Authorization
//   // 字段值: token值
//   config.headers.token = "efky789adfe88safd78iopk"
//   return config;
// }, function (error) {
//   // Do something with request error
//   return Promise.reject(error);
// });

Vue.use(VueRouter)

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)


Vue.config.productionTip = false
let router = new VueRouter({
  mode: 'history',
  base: '/lifeJK/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes
})
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
	